import React, { useEffect, useState } from "react";
import AuthMainTitle from "../command/authMainTitle/authMainTitle";
import InputForm from "../command/input/inputField";
import { Form } from "react-bootstrap";
import Button from "../command/Button/Button";
import { Effect } from "../../assets/svgIcon/customIcon";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { userClient } from "../../data/user";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
const resetFormSchema = yup.object().shape({
  password: yup
    .string()
    .required("New Password is required")
    .matches(passwordRules, {
      message: "Please create a stronger password.",
    }),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref("password")], "Password does not match.")
    .required("Confirmation password is required"),
});

const ChangePasswordForm = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [decodedEmail, setDecodedEmail] = useState("");
  const requestData = location.state;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    //@ts-ignore
    resolver: yupResolver(resetFormSchema),
    mode: "all",
  });

  useEffect(() => {
    // Get email from query string and decode from base64
    const emailParam = searchParams.get("email");
    if (emailParam) {
      try {
        // Decode base64 email
        const decoded = atob(emailParam);
        setDecodedEmail(decoded);
      } catch (error) {
        console.error("Error decoding email:", error);
      }
    }
  }, [searchParams]);

  const guestUser: boolean = requestData?.userTypeId === 6 || !!decodedEmail;

  const onSubmit = async (values: any) => {
    // Use decoded email from query string if available, otherwise use from requestData
    const username = decodedEmail || requestData?.username;

    const value = {
      username: username,
      otp: requestData?.otp,
      newPassword: values.password,
      userTypeId: guestUser ? 6 : 1,
    };
    userClient
      .resetPassword(value)
      .then((response: any) => {
        if (response.success) {
          toast.success("Password Changed Successfully.");
          if (decodedEmail) {
            navigate("/password-reset-success");
          } else {
            navigate("/login");
          }
        } else {
          toast.error(response.error);
        }
      })
      .catch((error: any) => {
        toast.error(error?.message);
      });
  };

  return (
    <div className="login-form-section signup-form-section">
      <div className="effect-add-section auth-page-effect">
        <Effect className="effect-img" />
        <AuthMainTitle
          mainTitleText={guestUser ? t("set-password") : t("reset-password")}
          className="login-title"
        />
        <div className="user-email-box">
          <h3 className="user-email">{decodedEmail || requestData?.username}</h3>
        </div>
        <Form>
          <InputForm
            inputId="login-password"
            inputLable={guestUser ? t("input-label-password") : t("input-label-new-password")}
            inputType="password"
            required
            register={register("password")}
            inputPlaceholder={guestUser ? t("input-label-password") : t("input-label-new-password")}
            error={errors?.password?.message}
          />
          <InputForm
            inputId="login-password"
            inputLable={t("input-label-confirm-password")}
            inputType="password"
            required
            register={register("passwordConfirmation")}
            inputPlaceholder={t("input-label-confirm-password")}
            error={errors?.passwordConfirmation?.message}
          />
        </Form>
        <p className="password-note">{t("password-validation-message")}</p>
        <div className="form-btn-section">
          <Button
            btnText={t("continue")}
            type="submit"
            disabled={!isValid}
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
